<template>
  <div class="h-full px-4">
    <div v-if="!dataAvailable && loaded" class="h-full flex justify-center">
      <p  v-if="filter === 'orders'" class="self-center -mt-6 text-center ">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.orders').toLowerCase()}) }}</p>
      <p  v-if="filter === 'sales'" class="self-center -mt-6 text-center ">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.sales').toLowerCase()}) }}</p>
      <p  v-if="filter === 'views'" class="self-center -mt-6 text-center ">{{ $t('widget.noDataForPill', {pill: $t('widget.filters.views').toLowerCase()}) }}</p>
    </div>
      <div v-show="loaded && dataAvailable" class=" w-full mt-4 border-2 	rounded-lg border-solid  border-gray-200">
        <div class="w-full  divide-y divide-gray-300">
          <div class="flex w-full px-3 justify-between ">
            <p class=" py-1 text-sm font-semibold text-gray-900">{{ $t('widget.topProducts.tableTitle') }}</p>

            <p v-if="filter === 'orders'"  class="py-1    text-right text-sm font-semibold text-gray-900 ">{{ $t('widget.filters.orders') }}</p>
            <p v-if="filter === 'sales'"  class="py-1  text-right text-sm font-semibold text-gray-900 ">{{ $t('widget.filters.sales') }}</p>
            <p v-if="filter === 'views'"  class="py-1    text-right text-sm font-semibold text-gray-900 ">{{ $t('widget.filters.views') }}</p>
          </div>
          <div class="divide-y  divide-gray-300">
              <table-item-with-image v-for="(item, index) in items"
                                     :isCurrency="isCurrency"
                                     :key="item.id"
                                     :productName="item.productName"
                                     :productCode="item.productCode"
                                     :imageUrl="item.imageUrl"
                                     :amount="numbers[index]"
                                     :amountItems="items.length"
                                     :position="index">
              </table-item-with-image>
          </div>
        </div>
    </div>
    <div v-if="!loaded" class="flex h-full items-center justify-center">
      <div class="loader loader--style3">
        <svg id="loader-1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="80px" height="80px" viewBox="0 0 50 50"  xml:space="preserve">
          <path class="loadingSpinner h-20" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
            <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite"/>
            </path>
          </svg>
      </div>
    </div>
  </div>

</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import TableItemWithImage from "@/widgetContent/listItems/TableItemWithImage";
import ApiService from "@/services/ApiService";

import {useApiStore} from "@/stores/ApiStore";

const apiDataStore = useApiStore();
let apiService = new ApiService();

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})
let items = ref(null);
let infoUrl = ref('');
let url = ref('');
let filter = ref("");
let isCurrency = ref(false);
let numbers = ref(Array);
let loaded = ref(false);
let dataAvailable = ref();
let currentEndpoint = ref();
const emit = defineEmits(["dataLoaded"])

onMounted ( async () => {
  props.pills.forEach(el => {
    if (el.selected === true)
    {
      url.value = el.source;
      isCurrency.value = url.value.slice(-5) === "sales";
    }
  });
  currentEndpoint.value = url.value
  await getData(currentEndpoint.value, isCurrency)
  }
)

async function getData(url, isCurrency)
{
  loaded.value = false;
  filter.value = url.substring(url.lastIndexOf('/')+1);
  let apiData = await apiService.get(url);
  emit("dataLoaded")
  items.value = apiData.data;
  numbers.value = [];
  if(! items.value.length >0) {
    dataAvailable.value = false
  }else {
    dataAvailable.value = true
    items.value.forEach(entry => {
      if (isCurrency.value)
      {
        numbers.value.push(formatter.format(parseInt(entry.amount)/100).toString());
      }
      else
      {
        numbers.value.push(entry.amount.toString());
      }
    })
    infoUrl.value = apiData.moreInfoUrl;
  }
  loaded.value = true;
}

watch(() => [props.update, props.source], async () => {
  loaded.value = false;
  isCurrency.value = props.source.slice(-5) === "sales";
  await getData(props.source, isCurrency);
})


const formatter = new Intl.NumberFormat(apiDataStore.getLang, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
});
</script>